import { render } from "./YearOverYearExpenseWidget.vue?vue&type=template&id=46dd1373"
import script from "./YearOverYearExpenseWidget.vue?vue&type=script&lang=js"
export * from "./YearOverYearExpenseWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__